/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type InvoiceRecapitulationType = 'Undefined' | 'InvoiceLinesTotal' | 'PaidAdvance' | 'Rounding' | 'Total';

export const InvoiceRecapitulationType = {
    Undefined: 'Undefined' as InvoiceRecapitulationType,
    InvoiceLinesTotal: 'InvoiceLinesTotal' as InvoiceRecapitulationType,
    PaidAdvance: 'PaidAdvance' as InvoiceRecapitulationType,
    Rounding: 'Rounding' as InvoiceRecapitulationType,
    Total: 'Total' as InvoiceRecapitulationType
};